import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {EventService} from "../../../services/event.service";
import {Subject} from "rxjs";
import {ActivityChart} from "./activity-chart";
import {Activity, Program, SchedulingParams, SiteTopology} from "../../../domain/cloud-topology";
import {ChartService} from "../../../services/chart.service";
import {takeUntil} from "rxjs/operators";


@Component({
    selector: 'app-activity-chart',
    templateUrl: './activity-chart.component.html',
    styleUrls: ['./activity-chart.component.scss'],
    standalone: false
})
export class ActivityChartComponent implements OnInit, OnChanges, OnDestroy {
  @Input() sites: SiteTopology[];
  @Input() programs: Program[];
  @Input() activities: Activity[];
  @Input() filterEvent: SchedulingParams;
  activityChart: ActivityChart;

  chartId: string = 'activityChart';
  noStats: boolean;
  loading: boolean;
  holdUpdates: boolean = false;

  private componentDestroyed$ = new Subject<void>();
  constructor(private eventService: EventService) {}

  ngOnInit() {
    this.eventService.sideNavButton$.pipe(takeUntil(this.componentDestroyed$)).subscribe(() => this.activityChart.resize());
    this.noStats = true;
    this.loading = false;
    this.holdUpdates = false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filterEvent']) {
      this.filterEvent = changes['filterEvent']['currentValue'];
    }

    if (changes['activities']) {
      this.activities = changes['activities']['currentValue'];
    }

    if (this.sites && this.activities) {
      this.getActivities();
    }
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next();
    this.componentDestroyed$.complete();
  }

  getActivities(): void {
    ChartService.setGlobals(this.filterEvent.timezone);
    if (!document.querySelector(`#${this.chartId}`)) {
      setTimeout(() => {this.getActivities();}, 1000);
      return;
    }
    this.activityChart = new ActivityChart(this.chartId, this.filterEvent.startDate, this.filterEvent.stopDate, this.sites, this.activities);
    this.activityChart.redraw();
  }
}
